import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot} from '@angular/router';
import {map, Observable, take} from 'rxjs';
import {AuthService} from '../services/auth.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
    private readonly authService = inject(AuthService);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        const url = state?.url ?? '';
        // Keycloak возвращает нас с `?code=...&state=...`. Если заблокировать этот URL,
        // получится цикл редиректов.
        const isOidcCallback = url.includes('code=') && url.includes('state=');
        if (isOidcCallback) return true;

        const isExternal = !!route?.url.length && route?.url[0].path === 'external';
        if (isExternal) return true;

        // Права здесь не смотрим: у токена может не оказаться claim'а resource_access,
        // и его отсутствие читалось бы как «прав нет» — в портал улетел бы обычный
        // пользователь. Авторитетный источник — /current (CurrentService) и ответы 403,
        // которые разбирает BasicAuthInterceptor.

        // checkAuth() отрабатывает в APP_INITIALIZER до старта приложения, поэтому
        // значение isAuthenticated$ здесь уже актуальное — ждать нечего.
        return this.authService.isAuthenticated$.pipe(
            take(1),
            map((isAuthenticated) => {
                if (!isAuthenticated) {
                    // Сессии нет или она истекла: уходим на Keycloak и возвращаемся
                    // в тот же раздел, а не остаёмся на пустой странице.
                    this.authService.loginSso(url || '/');
                    return false;
                }

                return true;
            }),
        );
    }
}
